export default __webpack_public_path__ + "static/media/fotoPersonal.9ac129ca.jpeg";